import { Component, h, Host, Listen, Prop, State, Element } from '@stencil/core';

@Component({
  tag: 'bam-news-filter',
  styleUrl: 'bam-news-filter.scss',
  shadow: false,
})
export class BamNewsFilter {
  @Element() host: HTMLElement;
  @Prop() url?: string;
  @Prop() limit?: number;
  @State() noResultMessage?: string;
  private previousCategory: boolean = null;
  private masonaryGrid: HTMLElement;
  private loadPositionBack: boolean = false;
  private sessionStorageFilterName = `${document.baseURI}-filter`;
  private sessionStorageJumpMarkName = `${document.baseURI}-jumpmark`;
  private backJumpStore: any = JSON.parse(sessionStorage.getItem(this.sessionStorageFilterName));

  @Listen('loadedMoreComplete', { target: 'window' })
  onLoadedMoreComplete() {
    this.backJumpStore = { ...this.backJumpStore, count: this.masonaryGrid.childElementCount };
    sessionStorage.setItem(this.sessionStorageFilterName, JSON.stringify(this.backJumpStore));
    if (this.loadPositionBack) {
      this.loadPositionBack = false;
      setTimeout(() => {
        this.loadScrollPosY();
      }, 100);
    }
  }

  componentWillLoad() {
    const entries = performance.getEntriesByType("navigation");
    if(entries[0]['type'] === 'reload' || entries[0]['type'] === 'back_forward') {
      if (this.backJumpStore?.category) {
        const selectField: HTMLSelectElement = this.host.querySelector(`[name=${this.backJumpStore.target}]`);
        selectField.value = this.backJumpStore.category;
      }
    }
  }

  componentDidLoad() {
    this.masonaryGrid = this.host.querySelector('.masonary-grid');
    const entries = performance.getEntriesByType("navigation");
    if(entries[0]['type'] === 'reload' || entries[0]['type'] === 'back_forward'){
      if ((this.backJumpStore?.count && this.backJumpStore?.category !== null) ||
        (this.backJumpStore?.category === null && this.backJumpStore?.count > this.limit)) {
        this.loadPositionBack = true;
        this.removeChildren();
        this.loadItems(this.backJumpStore.category, this.backJumpStore.target, this.backJumpStore.count);
      } else {
        window.addEventListener('balAppLoad', this.loadScrollPosY);
      }
    }

    window.addEventListener('beforeunload', this.saveScrollPosY);
  }

  loadScrollPosY = () => {
    if (sessionStorage.getItem(this.sessionStorageJumpMarkName)) {
      document.documentElement.scrollTop = Number.parseInt(sessionStorage.getItem(this.sessionStorageJumpMarkName));
      sessionStorage.removeItem(this.sessionStorageJumpMarkName);
    }
  };

  saveScrollPosY = () => {
    sessionStorage.setItem(this.sessionStorageJumpMarkName, `${window.scrollY}`);
  };

  @Listen('balChange')
  onBalChange(event) {
    this.removeChildren();
    this.loadItems(event.detail, event.target.id);
  }

  loadItems(detail, target, count = 0) {
    (async () => {
      await customElements.whenDefined('bam-load-more');
      const loadMoreElement = document.querySelector('bam-load-more') as HTMLBamLoadMoreElement;

      if (this.url && (this.previousCategory !== detail || count)) {
        this.previousCategory = detail;
        setTimeout(async () => {
          await loadMoreElement
            .requestItems(`${this.url}?offset=0${(detail && '&category=' + detail) || ''}${(count && '&limit=' + count) || ''}`)
            .then(() => {
                if (detail) {
                  loadMoreElement.setAttribute('category', detail);
                  loadMoreElement.offset = loadMoreElement.limit;
                } else {
                  loadMoreElement.removeAttribute('category');
                  loadMoreElement.offset = loadMoreElement.limit;
                }
                if(count){
                  loadMoreElement.offset = count;
                }
                this.backJumpStore = { ...this.backJumpStore, category: detail, target };
              },
            );
        }, 100);
      }
    })();
  }

  removeChildren() {
    while (this.masonaryGrid.firstChild) {
      this.masonaryGrid.removeChild(this.masonaryGrid.firstChild);
    }
  }

  render() {
    return (
      <Host>
        <slot name='filterForm'></slot>
        <slot></slot>
      </Host>
    );
  }
}
